"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _tether = _interopRequireDefault(require("tether"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
if (!_tether.default) {
  console.error('It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether');
}
var renderElementToPropTypes = [_propTypes.default.string, _propTypes.default.shape({
  appendChild: _propTypes.default.func.isRequired
})];
var childrenPropType = function childrenPropType(_ref, propName, componentName) {
  var children = _ref.children;
  var childCount = _react.Children.count(children);
  if (childCount > 0) {
    return new Error("".concat(componentName, " no longer uses children to render components. Please use renderTarget and renderElement instead."));
  }
};
var attachmentPositions = ['auto auto', 'top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'];
var TetherComponent = /*#__PURE__*/
function (_Component) {
  _inherits(TetherComponent, _Component);
  function TetherComponent() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TetherComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TetherComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_targetNode", _react.default.createRef());
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_elementNode", _react.default.createRef());
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_elementParentNode", null);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tetherInstance", null);
    return _this;
  }
  _createClass(TetherComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._createContainer(); // The container is created after mounting
      // so we need to force an update to
      // enable tether
      // Cannot move _createContainer into the constructor
      // because of is a side effect: https://reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects

      this.forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the container related props have changed, then update the container
      if (prevProps.renderElementTag !== this.props.renderElementTag || prevProps.renderElementTo !== this.props.renderElementTo) {
        this._createContainer();
      } // Verify if className props have changed

      if (this._elementParentNode && prevProps.className !== this.props.className) {
        var _this$_elementParentN, _this$_elementParentN2;

        // Add a bunch of checks against weird classNames
        var prevClasses = (prevProps.className || '').split(' ').filter(function (value) {
          return value.length > 0;
        });
        var currClasses = (this.props.className || '').split(' ').filter(function (value) {
          return value.length > 0;
        });
        (_this$_elementParentN = this._elementParentNode.classList).remove.apply(_this$_elementParentN, _toConsumableArray(prevClasses));
        (_this$_elementParentN2 = this._elementParentNode.classList).add.apply(_this$_elementParentN2, _toConsumableArray(currClasses));
      }
      this._update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._destroy();
    }
  }, {
    key: "getTetherInstance",
    value: function getTetherInstance() {
      return this._tetherInstance;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._tetherInstance.disable();
    }
  }, {
    key: "enable",
    value: function enable() {
      this._tetherInstance.enable();
    }
  }, {
    key: "on",
    value: function on(event, handler, ctx) {
      this._tetherInstance.on(event, handler, ctx);
    }
  }, {
    key: "once",
    value: function once(event, handler, ctx) {
      this._tetherInstance.once(event, handler, ctx);
    }
  }, {
    key: "off",
    value: function off(event, handler) {
      this._tetherInstance.off(event, handler);
    }
  }, {
    key: "position",
    value: function position() {
      this._tetherInstance.position();
    }
  }, {
    key: "_runRenders",
    value: function _runRenders() {
      // To obtain the components, we run the render functions and pass in the ref
      // Later, when the component is mounted, the ref functions will be called
      // and trigger a tether update
      var targetComponent = typeof this.props.renderTarget === 'function' ? this.props.renderTarget(this._targetNode) : null;
      var elementComponent = typeof this.props.renderElement === 'function' ? this.props.renderElement(this._elementNode) : null; // Check if what has been returned is a valid react element

      if (!(0, _react.isValidElement)(targetComponent)) {
        targetComponent = null;
      }
      if (!(0, _react.isValidElement)(elementComponent)) {
        elementComponent = null;
      }
      return {
        targetComponent: targetComponent,
        elementComponent: elementComponent
      };
    }
  }, {
    key: "_createTetherInstance",
    value: function _createTetherInstance(tetherOptions) {
      if (this._tetherInstance) {
        this._destroy();
      }
      this._tetherInstance = new _tether.default(tetherOptions);
      this._registerEventListeners();
    }
  }, {
    key: "_destroyTetherInstance",
    value: function _destroyTetherInstance() {
      if (this._tetherInstance) {
        this._tetherInstance.destroy();
        this._tetherInstance = null;
      }
    }
  }, {
    key: "_registerEventListeners",
    value: function _registerEventListeners() {
      var _this2 = this;
      this.on('update', function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return _this2.props.onUpdate && _this2.props.onUpdate.apply(_this2, args);
      });
      this.on('repositioned', function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        return _this2.props.onRepositioned && _this2.props.onRepositioned.apply(_this2, args);
      });
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this._destroyTetherInstance();
      this._removeContainer();
    }
  }, {
    key: "_createContainer",
    value: function _createContainer() {
      // Create element node container if it hasn't been yet
      this._removeContainer();
      var _this$props = this.props,
        renderElementTag = _this$props.renderElementTag,
        className = _this$props.className; // Create a node that we can stick our content Component in

      this._elementParentNode = document.createElement(renderElementTag);
      this._elementParentNode.className = className || '';
    }
  }, {
    key: "_addContainerToDOM",
    value: function _addContainerToDOM() {
      // Append node to the render node
      if (this._elementParentNode.parentNode !== this._renderNode) {
        this._renderNode.appendChild(this._elementParentNode);
      }
    }
  }, {
    key: "_removeContainer",
    value: function _removeContainer() {
      if (this._elementParentNode && this._elementParentNode.parentNode) {
        this._elementParentNode.parentNode.removeChild(this._elementParentNode);
      }
    }
  }, {
    key: "_update",
    value: function _update() {
      // If no element component provided, bail out
      var shouldDestroy = !this._elementNode.current || !this._targetNode.current;
      if (shouldDestroy) {
        // Destroy Tether element if it has been created
        this._destroy();
        return;
      }
      this._updateTether();
    }
  }, {
    key: "_updateTether",
    value: function _updateTether() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        renderElementTag = _this$props2.renderElementTag,
        renderElementTo = _this$props2.renderElementTo,
        id = _this$props2.id,
        className = _this$props2.className,
        style = _this$props2.style,
        renderTarget = _this$props2.renderTarget,
        renderElement = _this$props2.renderElement,
        options = _objectWithoutProperties(_this$props2, ["children", "renderElementTag", "renderElementTo", "id", "className", "style", "renderTarget", "renderElement"]);
      var tetherOptions = _objectSpread({
        target: this._targetNode.current,
        element: this._elementParentNode
      }, options);
      var idStr = id || '';
      if (this._elementParentNode.id !== idStr) {
        this._elementParentNode.id = idStr;
      }
      if (style) {
        var elementStyle = this._elementParentNode.style;
        Object.keys(style).forEach(function (key) {
          if (elementStyle[key] !== style[key]) {
            elementStyle[key] = style[key];
          }
        });
      }
      this._addContainerToDOM();
      if (this._tetherInstance) {
        this._tetherInstance.setOptions(tetherOptions);
      } else {
        this._createTetherInstance(tetherOptions);
      }
      this._tetherInstance.position();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$_runRenders = this._runRenders(),
        targetComponent = _this$_runRenders.targetComponent,
        elementComponent = _this$_runRenders.elementComponent;
      if (!targetComponent) {
        return null;
      }
      return _react.default.createElement(_react.default.Fragment, null, targetComponent, elementComponent && this._elementParentNode && _reactDom.default.createPortal(elementComponent, this._elementParentNode));
    }
  }, {
    key: "_renderNode",
    get: function get() {
      var renderElementTo = this.props.renderElementTo;
      if (typeof renderElementTo === 'string') {
        return document.querySelector(renderElementTo);
      }
      return renderElementTo || document.body;
    }
  }]);
  return TetherComponent;
}(_react.Component);
_defineProperty(TetherComponent, "propTypes", {
  renderElementTag: _propTypes.default.string,
  renderElementTo: _propTypes.default.oneOfType(renderElementToPropTypes),
  attachment: _propTypes.default.oneOf(attachmentPositions).isRequired,
  targetAttachment: _propTypes.default.oneOf(attachmentPositions),
  offset: _propTypes.default.string,
  targetOffset: _propTypes.default.string,
  targetModifier: _propTypes.default.string,
  enabled: _propTypes.default.bool,
  classes: _propTypes.default.object,
  classPrefix: _propTypes.default.string,
  optimizations: _propTypes.default.object,
  constraints: _propTypes.default.array,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  onUpdate: _propTypes.default.func,
  onRepositioned: _propTypes.default.func,
  renderTarget: _propTypes.default.func,
  renderElement: _propTypes.default.func,
  children: childrenPropType
});
_defineProperty(TetherComponent, "defaultProps", {
  renderElementTag: 'div',
  renderElementTo: null
});
var _default = TetherComponent;
exports.default = _default;